import { render, staticRenderFns } from "./ShoppingListIndex.vue?vue&type=template&id=64c0ac74&"
import script from "./ShoppingListIndex.vue?vue&type=script&lang=ts&"
export * from "./ShoppingListIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports